import { render, staticRenderFns } from "./AddTemplateForm.vue?vue&type=template&id=1cafea63&scoped=true"
import script from "./AddTemplateForm.vue?vue&type=script&lang=js"
export * from "./AddTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./AddTemplateForm.vue?vue&type=style&index=0&id=1cafea63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cafea63",
  null
  
)

export default component.exports